module.exports = __webpack_public_path__ + "img/store-neto.3a2f4bad.svg";